import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardHeader,FormGroup, Form, InputGroup, InputGroupAddon, InputGroupButton,Label, CardBody, Input, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import { ajaxWrapperGet,ajaxWrapperPost } from '../../utils/deviceAPI';
import LoadingIndicator from '../../utils/LoadingIndicator'



//google maps

class VerifyPhone extends Component {
    constructor() {
        super();
        this.state = { data: [
            {

                initializer: 0,
            },
            {
                initializer: 0,
            }

        ],
            loading: true

        };
        this.requestControlAuth = this.requestControlAuth.bind(this);
        this.verifyPIN = this.verifyPIN.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        ajaxWrapperGet('/api/user/controlAccess').then((data) => {
            this.setState({
                data,
                loading: false,
                verification: data.errorCase === 1 && data.error === true,
                verificationSuccess: data.errorCase === 0,
                smsReceived: false,
            });

        });
    }
    requestControlAuth() {
        ajaxWrapperGet('/api/getControlAccess').then((data) => {
            this.setState({
                data,
                verification: data.error,
                smsReceived: true,
                verificationSuccess: false
            });
        });
    }
    verifyPIN() {
        let postData = {
            pin: this.state.password
        };
        ajaxWrapperPost('/api/verifyControlAccess',postData).then((data) => {
            if (data.error === false) {
                this.setState({
                    data,
                    verification: false,
                    smsReceived: false,
                    verificationSuccess: true
                });
            }
            if (data.error === true) {
                this.setState({
                    data : {
                        message : data.message
                    }
                });
            }
        });
    }
    handleChange({ target }) {
        console.log(target.name + ' and ' + target.value);
        this.setState({
            [target.name]: target.value
        });
    }
    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        const { data } = this.state;
        console.log(data);
        //console.log(data);
        if (this.state.verificationSuccess) {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" lg="12" xl="3" >
                        </Col>
                        <Col xs="12" lg="12" xl="6">
                            <Card className="text-white bg-success text-center">
                                <CardBody className="card-body">
                                    <blockquote className="card-bodyquote">
                                        <p>{data.message}</p>
                                    </blockquote>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" lg="12" xl="3" >
                        </Col>
                    </Row>
                </div>
            )
        }
        else if (this.state.verification) {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" lg="12" xl="3" >
                        </Col>
                        <Col xs="12" lg="12" xl="6">
                            <Card className="text-white bg-info text-center">
                                <CardBody className="card-body">
                                    <blockquote className="card-bodyquote">
                                        <p><strong>{data.message}</strong></p>
                                        <blockquote className="card-bodyquote">
                                            <p>To verify your identity, please click the Verify button below. We will then send a text message containing a PIN to your phone number ending in <strong>{data.tel}</strong></p>
                                        </blockquote>
                                        <Button color="light" onClick={this.requestControlAuth}>Verify</Button>
                                    </blockquote>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" lg="12" xl="3" >
                        </Col>
                    </Row>
                </div>
            )
        }
        else if (this.state.smsReceived) {
            return (
                <div className="animated fadeIn">
                    <Row>
                        <Col xs="12" lg="12" xl="3" >
                        </Col>
                        <Col xs="12" lg="12" xl="6">
                            <Card className="text-white bg-info text-center">
                                <CardBody className="card-body">
                                    <blockquote className="card-bodyquote">
                                        <p>{data.message}</p>
                                            <InputGroup className="mb-4">
                                                <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="icon-lock"></i>
                                                </span>
                                                </div>
                                                <Input type="password" placeholder="PIN" name="password" value={ this.state.pin } onChange={this.handleChange} required/>
                                                <Button color="light" className="px-4" onClick={this.verifyPIN}>Verify PIN</Button>
                                            </InputGroup>
                                        <Button color="info" className="text-light" onClick={this.requestControlAuth}>Click here to resend message</Button>
                                    </blockquote>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" lg="12" xl="3" >
                        </Col>
                    </Row>
                </div>
            )
        }




    }
}
export default VerifyPhone;



// WEBPACK FOOTER //
// ./src/views/Userconfig/VerifyPhone.js